import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Login.css";
import MasterEdLogo from "../assets/masteredlogo-removebg-preview.png";
import authService from "../services/authService";
import { initTawk, hideTawk } from "../services/tawk";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton } from '@mui/material';

const Login = ({ setUserData }) => {
  const [studentId, setStudentId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (authService.isLoggedIn()) {
      navigate("/dashboard");
    }
  }, [navigate]);

  // Mount Tawk chat on Login page only
  useEffect(() => {
    const studentPk =
      localStorage.getItem("student_pk") || localStorage.getItem("student_id") || "";
    initTawk({
      visitor: studentPk ? { name: `Student ${studentPk}` } : undefined,
      attributes: {
        page: "login",
        studentId: studentPk,
      },
    });
    return () => hideTawk();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const student = await authService.login(studentId.trim(), password);
      setUserData?.({
        studentId: student.studentId,
        firstName: student.firstName,
        lastName: student.lastName,
        fullName: `${student.firstName} ${student.lastName}`,
      });
      navigate("/dashboard");
    } catch (err) {
      setError(err.message || "Authentication failed. Please check your Student ID and password and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {}
      <h1 className="login-welcome">Welcome to Master Education Testing Platform!</h1>
      <div className="login-card">
        {}
        <img src={MasterEdLogo} alt="Watermark" className="login-card-watermark" />
        <h2>Sign In with a Master Education Account</h2>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="studentId">Student ID</label>
            <input
              type="text"
              id="studentId"
              value={studentId}
              onChange={(e) => setStudentId(e.target.value)}
              required
              className="login-input"
              placeholder="Enter your student ID"
            />
          </div>

          <div className="input-group password-input-container">
            <label htmlFor="password">Password</label>
            <div className="password-input-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="login-input"
                placeholder="Enter your password"
              />
              <IconButton
                className="toggle-password"
                onClick={() => setShowPassword((p) => !p)}
                aria-label={showPassword ? "Hide password" : "Show password"}
                title={showPassword ? "Hide password" : "Show password"}
                size="small"
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </div>
          </div>

          {error && <p className="error-message">{error}</p>}
          <button type="submit" className="submit-btn">
            {loading ? "Signing In..." : "Sign In"}
          </button>
        </form>
        <div className="help-text-footer">
          <p>Если вы не знаете свои данные, пожалуйста, обратитесь к куратору</p>
        </div>
      </div>

      <div className="login-footer-graphics"></div>
    </div>
  );
};

export default Login;
